// extracted by mini-css-extract-plugin
module.exports = {"page":"_5DCIh7qU","section-card":"_5D8kXBpu","section-card--account-profile":"_5D2CmS9X","section-card--linked-networks":"_5D2p3wtw"};